// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"moods_scrollbar__hX2ih"};